export default function cancelablePromise(executor) {
    var resolvePromise;
    var rejectPromise;
    var promise;
    var onCancel;
    var canceled = false;
    var done = false;
    promise = new Promise(function (resolve, reject) {
        resolvePromise = function (value) {
            done = true;
            resolve(value);
        };
        rejectPromise = function (value) {
            done = true;
            reject(value);
        };
        executor(resolvePromise, rejectPromise, function (onCancelFn) {
            onCancel = onCancelFn;
        });
    });
    promise.cancel = function () {
        if (canceled || done) {
            return;
        }
        canceled = true;
        if (typeof onCancel === 'function') {
            onCancel();
        }
        rejectPromise(new Error('canceled'));
    };
    return promise;
}
